import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const softwareReportsControlEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-software-reports-control-entrypoint" */ './ui'),
	),
	getPreloadProps: () => ({}),
});
